import React, { useState, useEffect } from "react";
import Cookies from "js-cookie";
import { useParams } from "react-router-dom";
import axios from 'axios';

// Import de funções utilitárias
import { handleInputChange } from "./utils/handleInputChange";
import { money } from "./utils/money";
import { allInputChange } from "./utils/allInputChange";
import { changeInputName } from "./utils/changeInputName";
import { moneyInputChange } from "./utils/moneyInputChange";
import { dataFormato } from "./utils/dateFormato";
import { formatCpf_Cnpj } from "./utils/formatCpfCnpj";
import { handleInputChangeCel } from "./utils/handleInputChangeCel";
import { handleInputChangeCpf } from "./utils/handleInputChangeCpf";

// Import dos componentes das abas
import ProcessDescriptionAners from "./components/processDescriptionAners";
import AnexoTabAners from "./components/anexoTabAners";
import PagamentosTabAners from "./components/pagamentosTabAners";
import WorkflowTabAners from "./components/workflowTabAners";
import DocumentosTabAners from "./components/documentosTabAners";
import HistoricoGeral from "./components/historicoGeral";
import PrazoTabAners from "./components/prazoTabAners";

// Import dos modais de cadastro
import NovoPagamentoModal from "./modal/novoPagamentoModal";
import NovoForumModal from "./modal/novoForumModal";
import UpdatePagamentoModal from "./modal/updatePagamentoModal";
import NovaEntidadeModal from "./modal/novaEntidadeModal";
import NovoAutorModal from "./modal/novoAutorModal";
import NovoReuModal from "./modal/novoReuModal";
import NovoAdvogadoModal from "./modal/novoAdvogadoModal";
import NovoPrazoModal from "./modal/novoPrazoModal";

// Array completo de opções de bancos
const BANK_OPTIONS = [
    "1 - Banco do Brasil S.A.",
    "3 - Banco da Amazônia S.A.",
    "4 - Banco do Nordeste do Brasil S.A.",
    "7 - Banco Nacional de Desenvolvimento BNDES",
    "10 - Credicoamo",
    "12 - Banco Inbursa S.A.",
    "14 - Natixis Brasil S.A",
    "17 - BNY Mellon Banco S.A.",
    "18 - Banco Tricury S.A",
    "21 - BANESTES S.A. Banco do Estado do Espírito Santo",
    "24 - Banco BANDEPE S.A.",
    "25 - Banco Alfa S.A.",
    "29 - Banco Itaú Consignado S.A.",
    "33 - Banco Santander (Brasil) S.A.",
    "36 - Banco Bradesco BBI S.A.",
    "37 - Banco do Estado do Pará S.A.",
    "40 - Banco Cargill S.A.",
    "41 - Banco do Estado do Rio Grande do Sul S.A.",
    "47 - Banco do Estado de Sergipe S.A.",
    "62 - Hipercard Banco Múltiplo S.A.",
    "63 - Banco Bradescard S.A.",
    "65 - Banco Andbank (Brasil) S.A.",
    "66 - Banco Morgan Stanley S.A",
    "69 - Banco Crefisa S.A",
    "70 - BRB - Banco de Brasília S.A.",
    "74 - Banco J. Safra S.A.",
    "75 - Banco ABN AMRO S.A.",
    "76 - Banco KDB do Brasil S.A",
    "77 - Banco Inter S.A.",
    "82 - Banco Topázio S.A.",
    "83 - Banco da China Brasil S.A.",
    "94 - Banco Finaxis S.A.",
    "95 - Travelex Banco de Câmbio S.A.",
    "96 - Banco B3 S.A.",
    "102 - Banco XP S.A.",
    "104 - Caixa Econômica Federal",
    "107 - Banco BOCOM BBM S.A.",
    "119 - Banco Western Union do Brasil S.A.",
    "120 - Banco Rodobens S.A.",
    "121 - Banco Agibank S.A.",
    "125 - Banco Genial S.A.",
    "128 - MS Bank S.A. Banco de Câmbio",
    "129 - UBS Brasil Banco de Investimento S.A.",
    "144 - BEXS Banco de Câmbio S.A.",
    "169 - Banco Olé Bonsucesso Consignado S.A.",
    "184 - Banco Itaú BBA S.A.",
    "208 - Banco BTG Pactual S.A.",
    "212 - Banco Original S.A.",
    "217 - Banco John Deere S.A.",
    "218 - Banco BS2 S.A.",
    "222 - Banco Credit Agricole Brasil S.A.",
    "224 - Banco Fibra S.A.",
    "233 - Banco Cifra S.A.",
    "237 - Banco Bradesco S.A.",
    "243 - Banco Master S.A.",
    "246 - Banco ABC Brasil S.A.",
    "249 - Banco Investcred Unibanco S.A.",
    "250 - BCV - Banco de Crédito e Varejo S.A.",
    "254 - Paraná Banco S.A.",
    "260 - Nu Pagamentos S.A",
    "269 - HSBC Brasil S.A. - Banco de Investimento",
    "276 - Banco Senff S.A.",
    "290 - Pagseguro Internet S.A",
    "299 - Banco Sorocred S.A. - Banco Múltiplo (AFINZ)",
    "318 - Banco BMG S.A.",
    "320 - China Construction Bank (Brasil) Banco Múltiplo S.A.",
    "323 - Mercado Pago",
    "341 - Itaú Unibanco S.A.",
    "366 - Banco Société Générale Brasil S.A.",
    "370 - Banco Mizuho do Brasil S.A.",
    "376 - Banco J. P. Morgan S.A.",
    "389 - Banco Mercantil do Brasil S.A.",
    "394 - Banco Bradesco Financiamentos S.A.",
    "399 - Kirton Bank S.A. - Banco Múltiplo",
    "422 - Banco Safra S.A.",
    "456 - Banco MUFG Brasil S.A.",
    "464 - Banco Sumitomo Mitsui Brasileiro S.A.",
    "473 - Banco Caixa Geral - Brasil S.A.",
    "477 - Citibank N.A.",
    "479 - Banco ItauBank S.A",
    "487 - Deutsche Bank S.A. - Banco Alemão",
    "488 - JPMorgan Chase Bank, National Association",
    "492 - ING Bank N.V.",
    "505 - Banco Credit Suisse (Brasil) S.A.",
    "600 - Banco Luso Brasileiro S.A.",
    "604 - Banco Industrial do Brasil S.A.",
    "610 - Banco VR S.A.",
    "611 - Banco Paulista S.A.",
    "612 - Banco Guanabara S.A.",
    "623 - Banco PAN S.A.",
    "626 - Banco C6 Consignado S.A.",
    "630 - Banco Smartbank S.A.",
    "633 - Banco Rendimento S.A.",
    "634 - Banco Triângulo S.A.",
    "643 - Banco Pine S.A.",
    "653 - Banco Voiter S.A.",
    "654 - Banco Digimais S.A.",
    "655 - Banco Votorantim S.A.",
    "707 - Banco Daycoval S.A.",
    "739 - Banco Cetelem S.A.",
    "743 - Banco Semear S.A.",
    "745 - Banco Citibank S.A.",
    "746 - Banco Modal S.A.",
    "747 - Banco Rabobank International Brasil S.A.",
    "748 - Banco Cooperativo Sicredi S.A.",
    "751 - Scotiabank Brasil S.A. Banco Múltiplo",
    "752 - Banco BNP Paribas Brasil S.A.",
    "755 - Bank of America Merrill Lynch Banco Múltiplo S.A.",
    "756 - Banco Cooperativo do Brasil S.A. - BANCOOB",
];

// Array completo de tipos de pagamento
const PAYMENT_TYPES = [
    "Auto Infração Trabalhista",
    "Pagamento Acordo Execução",
    "Honorários Técnicos",
    "Custas AI",
    "Depósito Judicial",
    "Depósito Recursal RO",
    "Depósito Recursal RR",
    "Depósito Recursal AI",
    "Perito Contador",
    "Perito Médico",
    "Previdência",
    "Apólice RO",
    "Apólice RR",
    "Apólice AI",
    "Depósito Judicial execução",
    "Acordo",
    "Custas RO",
    "Custas RR",
    "Deposito Judicial execução provisória",
    "Pensão",
    "Depósito Judicial NÃO TRABALHISTA",
    "Custas processuais oficial de justiça",
    "Taxa de mandato",
];

function Aners({ response }) {
    console.log(response);
    const token = Cookies.get("ANers");
    const { id } = useParams();

    // Estados de utilização interna
    const [authenticated, setAuthenticated] = useState(false);
    const [responseProcess, setResponse] = useState(false);
    const [responseUsuario, setResponseUsuario] = useState(false);
    const [responseReu, setResponseReu] = useState(false);
    const [responseAutor, setResponseAutor] = useState(false);
    const [responseAdvogado, setResponseAdvogado] = useState(false);
    const [responsePagamento, setResponsePagamento] = useState(false);
    const [responseWorkflow, setResponseWorkflow] = useState(false);
    const [responseAcao, setResponseAcao] = useState(false);
    const [responseAnexo, setResponseAnexo] = useState(false);
    const [responseDocs, setResponseDocs] = useState(false);
    const [responsePessoa, setResponsePessoa] = useState(false);
    const [responseTimeLine, setResponseTimeLine] = useState(false);
    const [responseParam, setResponseParam] = useState(false);
    const [responseForum, setResponseForum] = useState(false);
    const [responsePrazos, setResponsePrazos] = useState(false); 
    const [valueCpf, setValueCpf] = useState("");
    const [valueCel, setValueCel] = useState("");
    const [selectedPayment, setSelectedPayment] = useState({
        tipo: null,
        descricao: null,
        valor: null,
        data_pagamento: null,
        anexo: null,
        nome: null,
        cpf: null,
        agencia: null,
        conta: null,
        banco: null,
        digito: null,
    });
    const [selectedDocs, setSelectedDocs] = useState([]);
    const [isDownloading, setIsDownloading] = useState(false);
    const [value, setValue] = useState("");
    let fileList = new DataTransfer();

    useEffect(() => {
        if (response.auth === true) {
            setAuthenticated(true);
            setResponse(response.resp);
            setResponseUsuario(response.usuario);
            setResponseReu(response.reus);
            setResponseAutor(response.autores);
            setResponseAdvogado(response.advogados);
            setResponsePagamento(response.pagamentos);
            setResponseWorkflow(response.workflows);
            setResponseAnexo(response.anexos);
            setResponseDocs(response.docs);
            setResponsePessoa(response.pessoas);
            setResponseParam(response.param);
            setResponseAcao(response.acao);
            setResponseTimeLine(response.timeline);
            setResponseForum(response.forum);
        } else {
            window.location = "/login";
        }
    }, [authenticated]);

    useEffect(() => {
        const getPrazos = async () => {
            try {
              const res = await axios.get(`/api/get/deadline/${id}`, {
                withCredentials: true,
              });
      
              console.log(res.data);
              if (res.data) {
                setResponsePrazos(res.data);
              } else {
                alert('Erro ao recuperar prazos');
              }
            } catch (error) {
              console.error('Erro no get de prazos:', error);
            }
        };
      
        getPrazos();
    }, [id])

    // Loop para caso não esteja autenticado
    if (!authenticated) {
        return (
            <div
                style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "100vh",
                }}
            >
                <div class="spinner-border" role="status">
                    <span class="sr-only">Loading...</span>
                </div>
            </div>
        );
    }
    function atualizarTitulo(titulo) {
        if (titulo < 1 || titulo > 8) {
            return;
        }
        switch (titulo) {
            case 1:
                document.querySelector("#titulo").textContent =
                    "Dados da Requisição";
                break;
            case 2:
                document.querySelector("#titulo").textContent =
                    "Prazos Solicitados";
                break;
            case 3:
                document.querySelector("#titulo").textContent = "Anexos Adicionados";
                break;
            case 4:
                document.querySelector("#titulo").textContent = "Pagamentos";
                break;
            case 5:
                document.querySelector("#titulo").textContent = "Status";
                break;
            case 6:
                document.querySelector("#titulo").textContent = "Documentos";
                break;
            default:
                console.log("Erro!");
        }
    }

    // * Objeto de prazos simulado para testes
    const simulatedResponsePrazos = [
        {
          id: 1,
          descricao: "Prazo para envio do comprovante do pagamento",
          data: "2025-03-20",
          status: "Aberto",
        },
        {
          id: 2,
          descricao: "Prazo para envio do comprovante de matrícula",
          data: "2025-03-25",
          status: "Encerrado",
        },
        {
          id: 3,
          descricao: "Prazo para atualização cadastral",
          data: "2025-04-01",
          status: "Aberto",
        },
      ];
      

    return (
        <>
            <section className="content">
                <div className="container-fluid" style={{ marginTop: 18 }}>
                    <div className="row">
                        <div className="col-12">
                            <div className="card">
                                <div className="card-body">
                                    {/* Nav Tabs */}
                                    <div className="row">
                                        <div className="container center-element">
                                            <ul
                                                className="nav nav-tabs nav-tabs-light flex-center"
                                                role="tablist"
                                            >
                                                <li
                                                    role="presentation"
                                                    className="nav-item"
                                                    onClick={() =>
                                                        atualizarTitulo(1)
                                                    }
                                                >
                                                    <a
                                                        href="#primeira-aba"
                                                        className="nav-link active"
                                                        aria-controls="primeira-aba"
                                                        role="tab"
                                                        data-toggle="tab"
                                                        aria-expanded="true"
                                                    >
                                                        <span className="hidden-xs hidden-sm">
                                                            Descrição
                                                        </span>
                                                    </a>
                                                </li>
                                                <li
                                                    role="presentation"
                                                    className="nav-item"
                                                    onClick={() =>
                                                        atualizarTitulo(2)
                                                    }
                                                >
                                                    <a
                                                        href="#segunda-aba"
                                                        className="nav-link"
                                                        aria-controls="segunda-aba"
                                                        role="tab"
                                                        data-toggle="tab"
                                                        aria-expanded="false"
                                                    >
                                                        <span className="hidden-xs hidden-sm">
                                                            Prazos
                                                        </span>
                                                    </a>
                                                </li>
                                                <li
                                                    role="presentation"
                                                    className="nav-item"
                                                    onClick={() =>
                                                        atualizarTitulo(3)
                                                    }
                                                >
                                                    <a
                                                        href="#terceira-aba"
                                                        className="nav-link"
                                                        aria-controls="terceira-aba"
                                                        role="tab"
                                                        data-toggle="tab"
                                                        aria-expanded="false"
                                                    >
                                                        <span className="hidden-xs hidden-sm">
                                                            Anexos
                                                        </span>
                                                    </a>
                                                </li>
                                                <li
                                                    role="presentation"
                                                    className="nav-item"
                                                    onClick={() =>
                                                        atualizarTitulo(4)
                                                    }
                                                >
                                                    <a
                                                        href="#quarta-aba"
                                                        className="nav-link"
                                                        aria-controls="quarta-aba"
                                                        role="tab"
                                                        data-toggle="tab"
                                                        aria-expanded="false"
                                                    >
                                                        <span className="hidden-xs hidden-sm">
                                                            Pagamentos
                                                        </span>
                                                    </a>
                                                </li>
                                                <li
                                                    role="presentation"
                                                    className="nav-item"
                                                    onClick={() =>
                                                        atualizarTitulo(5)
                                                    }
                                                >
                                                    <a
                                                        href="#quinta-aba"
                                                        className="nav-link"
                                                        aria-controls="quinta-aba"
                                                        role="tab"
                                                        data-toggle="tab"
                                                        aria-expanded="false"
                                                    >
                                                        <span className="hidden-xs hidden-sm">
                                                            Workflow
                                                        </span>
                                                    </a>
                                                </li>
                                                <li
                                                    role="presentation"
                                                    className="nav-item"
                                                    onClick={() =>
                                                        atualizarTitulo(6)
                                                    }
                                                >
                                                    <a
                                                        href="#sexta-aba"
                                                        className="nav-link"
                                                        aria-controls="sexta-aba"
                                                        role="tab"
                                                        data-toggle="tab"
                                                        aria-expanded="false"
                                                    >
                                                        <span className="hidden-xs hidden-sm">
                                                            Documentos
                                                        </span>
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>

                                    {/* Cabeçalho */}
                                    <div
                                        className="row"
                                        style={{ marginTop: -1 }}
                                    >
                                        <div className="col-12">
                                            <div className="card-header bg-info">
                                                <div className="inner text-center"></div>
                                                <h3
                                                    className="text-center"
                                                    id="titulo"
                                                >
                                                    Dados da Requisição
                                                </h3>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Conteúdo das Abas */}
                                    <div className="tab-content">
                                        <ProcessDescriptionAners
                                            id="primeira-aba"
                                            idProcess={id}
                                            token={token}
                                            responseProcess={responseProcess}
                                            responseForum={responseForum}
                                            responsePessoa={responsePessoa}
                                            responseAcao={responseAcao}
                                            setSelectedPayment={
                                                setSelectedPayment
                                            }
                                        />
                                        <PrazoTabAners
                                            id='segunda-aba'
                                            token={token}
                                            responsePrazos={responsePrazos}
                                            responseParam={responseParam}
                                            dataFormato={dataFormato}
                                        />
                                        <AnexoTabAners
                                            id="terceira-aba"
                                            token={token}
                                            responseProcess={responseProcess}
                                            responseAnexo={responseAnexo}
                                            fileList={fileList}
                                            dataFormato={dataFormato}
                                            responseParam={responseParam}
                                        />
                                        <PagamentosTabAners
                                            id="quarta-aba"
                                            token={token}
                                            responsePagamento={
                                                responsePagamento
                                            }
                                            dataFormato={dataFormato}
                                            money={money}
                                            selectedPayment={selectedPayment}
                                            setSelectedPayment={setSelectedPayment}
                                            responseParam={responseParam}
                                        />
                                        <WorkflowTabAners
                                            id="quinta-aba"
                                            token={token}
                                            idProcess={id}
                                            responseWorkflow={responseWorkflow}
                                            dataFormato={dataFormato}
                                        />
                                        <DocumentosTabAners
                                            id="sexta-aba"
                                            token={token}
                                            idProcess={id}
                                            responseDocs={responseDocs}
                                            selectedDocs={selectedDocs}
                                            setResponseDocs={setResponseDocs}
                                            setSelectedDocs={setSelectedDocs}
                                            setIsDownloading={setIsDownloading}
                                            isDownloading={isDownloading}
                                            fileList={fileList}
                                            responseParam={responseParam}
                                            dataFormato={dataFormato}
                                        />
                                    </div>

                                    {/* Histórico Geral */}
                                    <HistoricoGeral
                                        timeline={responseTimeLine}
                                    />
                                </div>
                                {/* Fim card-body */}
                            </div>
                            {/* Fim card */}
                        </div>
                    </div>
                </div>
            </section>
            <NovoPagamentoModal
                BANK_OPTIONS={BANK_OPTIONS}
                PAYMENT_TYPES={PAYMENT_TYPES}
                idProcess={id}
                token={token}
                formatCpf_Cnpj={formatCpf_Cnpj}
                responsePagamento={responsePagamento}
                handleInputChange={handleInputChange}
                setValue={setValue}
                value={value}
            />
            <NovoForumModal />
            <UpdatePagamentoModal
                BANK_OPTIONS={BANK_OPTIONS}
                PAYMENT_TYPES={PAYMENT_TYPES}
                token={token}
                changeInputName={changeInputName}
                selectedPayment={selectedPayment}
                allInputChange={allInputChange}
                setSelectedPayment={setSelectedPayment}
                moneyInputChange={moneyInputChange}
                formatCpf_Cnpj={formatCpf_Cnpj}
            />
            <NovaEntidadeModal
                idProcess={id}
                token={token}
                valueCel={valueCel}
                setValueCel={setValueCel}
                handleInputChangeCel={handleInputChangeCel}
                valueCpf={valueCpf}
                setValueCpf={setValueCpf}
                handleInputChangeCpf={handleInputChangeCpf}
            />
            <NovoAutorModal
                idProcess={id}
                token={token}
                responsePessoa={responsePessoa}
            />
            <NovoReuModal
                idProcess={id}
                token={token}
                responsePessoa={responsePessoa}
            />
            <NovoAdvogadoModal
                responsePessoa={responsePessoa}
                idProcess={id}
                token={token}
            />
            <NovoPrazoModal
                idProcess={id}
            />
        </>
    );
}

export default Aners;
